import React from 'react';

const Heading4 = (props) => (
    <h4 className={props.classname}>{props.title}</h4>
);


export default Heading4;